export const addFollower = async (name, email, sheetName, scriptUrl) => {
  return new Promise((resolve, reject) => {
    // Create a form element
    const form = document.createElement("form");
    form.method = "POST";
    form.action = scriptUrl; // Use the passed scriptUrl instead of hardcoded value

    // Add name field
    const nameField = document.createElement("input");
    nameField.type = "hidden";
    nameField.name = "name";
    nameField.value = name;
    form.appendChild(nameField);

    // Add email field
    const emailField = document.createElement("input");
    emailField.type = "hidden";
    emailField.name = "email";
    emailField.value = email;
    form.appendChild(emailField);

    // Add sheetName field (renamed from sheetId)
    const sheetNameField = document.createElement("input");
    sheetNameField.type = "hidden";
    sheetNameField.name = "sheetName";
    sheetNameField.value = sheetName || "default";
    form.appendChild(sheetNameField);

    // Create a hidden iframe to prevent page navigation
    const iframe = document.createElement("iframe");
    iframe.name = "hidden-iframe";
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    form.target = "hidden-iframe";

    // Set up message listener to get response
    window.addEventListener(
      "message",
      function handler(event) {
        if (event.data && event.data.result === "success") {
          window.removeEventListener("message", handler);
          document.body.removeChild(iframe);
          resolve(event.data);
        }
        if (event.data && event.data.result === "error") {
          window.removeEventListener("message", handler);
          document.body.removeChild(iframe);
          reject(event.data);
        }
      },
      false
    );

    // Submit the form
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);

    // Set a timeout in case we don't get a response
    setTimeout(() => {
      document.body.removeChild(iframe);
      resolve({
        result: "success",
        note: "No confirmation received, but request was sent",
      });
    }, 3000);
  });
};
